import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

const FsaProductDetails = (): JSX.Element => {
  const t = useTranslations();

  return (
    <article>
      <TypographyV3 Element="h1" variant="h3" className="mb-1">
        {t('comparisons_oura_title')}
      </TypographyV3>

      <TypographyV3 Element="h2" variant="h5" className="mb-4 leading-tight">
        {t('heart_rate_monitoring_slideshow_description')}
      </TypographyV3>

      <TypographyV3>{t('heart_rate_monitoring_pricing_details')}</TypographyV3>

      <div className="mt-6 border-t border-gray-200 px-2 pt-4">
        <ul className="mb-4 ml-6 list-disc">
          <li className="mb-2">{t('heart_rate_monitoring_listitem_1')}</li>
          <li className="mb-2">{t('heart_rate_monitoring_listitem_2')}</li>
          <li className="mb-2">{t('heart_rate_monitoring_listitem_3')}</li>
          <li className="mb-2">{t('heart_rate_monitoring_listitem_4')}</li>
        </ul>

        <TypographyV3>{t('heartrate_monitoring_pricing_note')}</TypographyV3>
      </div>
    </article>
  );
};

export default FsaProductDetails;
